import { fullscreenExcludeVideoOverlayStates } from "@/lib/constants";
import styles from "@/styles/Video.module.scss";
import { useCallback } from "react";
import NextEpisode from "./NextEpisode";
import classnames from "classnames";
import { jsx as _jsx } from "react/jsx-runtime";
export default function FullScreenOverlay(_ref) {
  let {
    state,
    prevState,
    error,
    watch,
    player,
    fullScreen
  } = _ref;
  const handleFirst = useCallback(() => {
    state.updateResumePoint(0);
  }, []);
  if (!state.overlay && !error) return null;
  if (fullScreen) {
    if (state.reason === "next_episode") {
      if (watch !== null && watch !== void 0 && watch.nextEpisode) {
        return /*#__PURE__*/_jsx("div", {
          className: classnames(styles.overlay, styles.fullScreen),
          children: /*#__PURE__*/_jsx(NextEpisode, {
            className: styles.fullScreen,
            watch: watch,
            state: state
          })
        });
      } else return null;
    } else if (state.reason === "resume") {
      // Windows Chromeでレジュームありの場合視聴開始しないので、視聴開始する
      handleFirst();
    } else if (!!state.reason && fullscreenExcludeVideoOverlayStates.includes(state.reason) || !!prevState.reason && fullscreenExcludeVideoOverlayStates.includes(prevState.reason)) {
      player === null || player === void 0 || player.exitFullscreen();
    }
  }
  return null;
}